import { ApiError } from "@/lib/api";

type TQuote = (key: string, opts?: Record<string, unknown>) => string;

/**
 * Maps an `ApiError` from `POST /cart/items/{slug}/lines` to a
 * user-friendly localised reason. Used by the Replace-DXF modal to
 * tell the user *why* a particular variant couldn't be carried over
 * (e.g. material missing in the new part's catalog) so they know what
 * to reconfigure manually.
 *
 * Falls back to a generic message for unknown codes / non-`ApiError`s
 * so the failure list never goes blank.
 */
export function formatCartLineError(err: unknown, tQuote: TQuote): string {
  if (err instanceof ApiError) {
    const key = `replace.errors.line.${err.code}`;
    const translated = tQuote(key, {
      defaultValue: "",
      ...err.params,
    });
    if (translated) return translated;
  }
  return tQuote("replace.errors.fallback");
}

export function formatChainOpError(err: unknown, tQuote: TQuote): string {
  if (err instanceof ApiError) {
    const key = `replace.errors.op.${err.code}`;
    const translated = tQuote(key, {
      defaultValue: "",
      ...err.params,
    });
    if (translated) return translated;
  }
  return tQuote("replace.errors.fallback");
}
